import {
    Component, Mixins,
} from 'vue-property-decorator';
import { YChips, YIcon, YImage } from '@components/index';
import Helpers from '@rogues/shared/mixins/helpers';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { date } from '@nodes/helpers/date';
import { get } from 'lodash/object';
import Props from './props';

@Component({
    components: {
        YIcon,
        YChips,
        YImage,
    },
})

/**
 * @name BlogCard
 */
export default class BlogCard extends Mixins(Props, Helpers, HybridMixin) {
    /**
     * Date helper
     */
    date = date;

    /**
     * Return router-link object
     *
     * @param {string} name
     * @param {object} post
     * @returns {object}
     */
    routeTo(name: string, post: Record<any, any>): object {
        const params: Record<any, any> = {};
        if (post?.url_encode) {
            params.url_encode = post.url_encode;
        } else if (post?.id) {
            params.id = post.id;
        }

        return {
            name,
            params,
        };
    }

    /**
     * Return best version of image
     *
     * @param {object} img
     * @returns {string}
     */
    imgSrc(img: any): string {
        return get(img, `versions.${this.getValue('imageVersion')}`, img.link);
    }
}
